module.exports = {"150823100":"乌拉山镇","150823101":"白彦花镇","150823102":"先锋镇","150823103":"新安镇","150823104":"西小召镇","150823105":"大佘太镇","150823106":"明安镇","150823107":"小佘太镇","150823108":"苏独仑镇","150823200":"额尔登布拉格苏木","150823201":"沙德格苏木","150823400":"巴彦淖尔市中滩农场","150823401":"巴彦淖尔市西山咀农场","150823402":"巴彦淖尔市新安农场","150823403":"巴彦淖尔市苏独仑农场","150823404":"巴彦淖尔市大佘太牧场","150823405":"巴彦淖尔市乌梁素海渔场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150823.json
// module id = 462
// module chunks = 0